import PropTypes from 'prop-types';
import { useEmailThreads } from './threads/email-threads-context';
import { useEmailDrafts } from './drafts/email-drafts-context';
import { useScheduledEmails } from './scheduled/scheduled-email-context';

const EmailTabGroup = ({ activeTab = 'Drafts', onTabChange = () => {} }) => {
  const { threadTotal = 0 } = useEmailThreads();
  const { draftTotal = 0 } = useEmailDrafts();
  const { scheduledTotal = 0 } = useScheduledEmails();

  return (
    <div className="email-tab-group-container">
      <div className="email-tab-group">
        <div
          className={`email-tab-group--item ${activeTab === 'Drafts' ? 'active-tab' : ''}`}
          onClick={() => onTabChange('Drafts')}
        >
          <span className="tab-text">Drafts{draftTotal > 0 ? ` ${draftTotal}` : ''}</span>
        </div>
        <span className="border-span">|</span>
        <div
          className={`email-tab-group--item ${activeTab === 'Scheduled' ? 'active-tab' : ''}`}
          onClick={() => onTabChange('Scheduled')}
        >
          <span className="tab-text">Scheduled{scheduledTotal > 0 ? ` ${scheduledTotal}` : ''}</span>
        </div>
        <span className="border-span">|</span>
        <div
          className={`email-tab-group--item ${activeTab === 'Sent' ? 'active-tab' : ''}`}
          onClick={() => onTabChange('Sent')}
        >
          <span className="tab-text">Sent{threadTotal > 0 ? ` ${threadTotal}` : ''}</span>
        </div>
      </div>
    </div>
  );
};

EmailTabGroup.propTypes = {
  activeTab: PropTypes.string,
  onTabChange: PropTypes.func,
};

export default EmailTabGroup;
